<div *ngIf="photo360FilePath" class="fullFrame">
<iframe title="" 
[src]="pannellumExternalUrl" id="pannellum-iframe" class="fullFrame">
</iframe>
</div>
<div *ngIf="photo360FilePath==null" class="fullFrame not-found">
    <h3>Não foi encontrada Foto 360 no local solicitado.</h3>
</div>
